export default {"src":"/_next/static/media/music_note.e4f9c444.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};